import React, { FC } from 'react';

import { CobrandImage } from '../CobrandImage/CobrandImage';
import { RichText } from '@marriott/mi-ui-library';
import { LinkTarget, ARIA_LABELS, StringBoolean } from '../../modules/constants/constants';
import { CardAwardBadgeProps } from './CardAwardBadge.types';
import { StyledCardAwardBadge } from './CardAwardBadge.styles';

export const CardAwardBadge: FC<CardAwardBadgeProps> = ({
  awardImagePath,
  awardAltText,
  awardUrl,
  awardUrlAriaLabel,
  awardOpeninNewTab,
  awardLegalText,
  customClass = '',
}) => {
  if (!awardImagePath || !awardAltText) {
    return null;
  }

  const imageComponent = (
    <CobrandImage
      defaultImageURL={awardImagePath}
      altText={awardAltText}
      customClass={`award-image ${customClass}`}
      data-testid="card-award-badge-img"
    />
  );

  if (awardUrl) {
    return (
      <StyledCardAwardBadge
        data-component-name="m-cobrand-CardAwardBadge"
        data-testid="card-award-badge"
        className="text-center"
      >
        <a
          href={awardUrl}
          target={
            awardOpeninNewTab === StringBoolean.TRUE || awardOpeninNewTab === true ? LinkTarget.BLANK : LinkTarget.SELF
          }
          rel={
            awardOpeninNewTab === StringBoolean.TRUE || awardOpeninNewTab === true ? 'noopener noreferrer' : undefined
          }
          aria-label={awardUrlAriaLabel}
          className="d-inline-block"
          data-testid="award-button-link"
        >
          {imageComponent}
        </a>
        {awardLegalText && (
          <RichText text={awardLegalText} componentId="award-legal-text" customClass="award-legal-text mt-2" />
        )}
      </StyledCardAwardBadge>
    );
  }

  return (
    <StyledCardAwardBadge
      data-component-name="m-cobrand-CardAwardBadge"
      data-testid="card-award-badge"
      className="mb-4"
    >
      {imageComponent}
      {awardLegalText && <RichText text={awardLegalText} componentId="award-legal-text" customClass="mt-2" />}
    </StyledCardAwardBadge>
  );
};

CardAwardBadge.displayName = 'CardAwardBadge';
